'use strict';

const { buildGalleryPropsFromAjaxImages } = require('public/templates/modules/product_media/utils/build-gallery-props-from-ajax-images');
const { getOrCreateGlobalStore } = require('./create-global-store');

const RP_PRODUCT_STORE_KEY = '__rp_product_store_v1';

/**
 * @param {unknown} cartPromoMessage
 * @returns {string}
 */
function normalizeCartPromoMessage(cartPromoMessage) {
	if (typeof cartPromoMessage !== 'string') {
		return '';
	}

	const trimmedMessage = cartPromoMessage.trim();
	return trimmedMessage === '' ? '' : cartPromoMessage;
}

/**
 * @param {Record<string, unknown>} islandProps
 * @returns {void}
 */
function seedCartPromoMessageFromIslandProps(islandProps) {
	const store = getProductStore();
	if (store.getState().isCartPromoMessageReady) {
		return;
	}

	store.setState({
		cartPromoMessage: normalizeCartPromoMessage(islandProps.cartPromoMessage),
		isCartPromoMessageReady: true,
	});
}

/**
 * @param {unknown} cartPromoMessage
 * @returns {void}
 */
function setCartPromoMessage(cartPromoMessage) {
	if (typeof cartPromoMessage !== 'string') {
		return;
	}

	getProductStore().setState({
		cartPromoMessage: normalizeCartPromoMessage(cartPromoMessage),
		isCartPromoMessageReady: true,
	});
}

/**
 * @param {Record<string, unknown>} islandProps
 * @returns {void}
 */
function seedGalleryFromIslandProps(islandProps) {
	const store = getProductStore();
	if (store.getState().isGalleryReady) {
		return;
	}

	store.setState((state) => ({
		catalog: islandProps.catalog ?? '',
		skuStripped: islandProps.skuStripped ?? '',
		gallery: {
			productImages: islandProps.productImages,
			mainImage: islandProps.mainImage ?? null,
			makeLogo: islandProps.makeLogo ?? null,
			hasYoutube: islandProps.hasYoutube,
			initialSelectedIndex: islandProps.initialSelectedIndex,
		},
		isGalleryReady: true,
		galleryRevision: state.galleryRevision + 1,
	}));
}

/**
 * @param {unknown} rawImages
 * @param {{
 *   fallbackImages?: unknown[],
 *   catalog?: string,
 *   skuStripped?: string,
 * }} [options]
 * @returns {void}
 */
function setGalleryFromAjaxImages(rawImages, options = {}) {
	const { catalog, skuStripped, ...gallery } = buildGalleryPropsFromAjaxImages(rawImages, options);

	getProductStore().setState((state) => ({
		catalog,
		skuStripped,
		gallery,
		isGalleryReady: true,
		galleryRevision: state.galleryRevision + 1,
	}));
}

/**
 * @returns {import('zustand/vanilla').StoreApi<{
 *   catalog: string,
 *   skuStripped: string,
 *   gallery: {
 *     productImages: unknown[],
 *     mainImage: unknown|null,
 *     makeLogo: unknown|null,
 *     hasYoutube: boolean,
 *     initialSelectedIndex: number,
 *   },
 *   galleryRevision: number,
 *   isGalleryReady: boolean,
 *   cartPromoMessage: string,
 *   isCartPromoMessageReady: boolean,
 * }>}
 */
function getProductStore() {
	return getOrCreateGlobalStore(RP_PRODUCT_STORE_KEY, () => ({
		catalog: '',
		skuStripped: '',
		gallery: {
			productImages: [],
			mainImage: null,
			makeLogo: null,
			hasYoutube: false,
			initialSelectedIndex: 0,
		},
		galleryRevision: 0,
		isGalleryReady: false,
		cartPromoMessage: '',
		isCartPromoMessageReady: false,
	}));
}

module.exports = {
	getProductStore,
	seedCartPromoMessageFromIslandProps,
	seedGalleryFromIslandProps,
	setCartPromoMessage,
	setGalleryFromAjaxImages,
};
